import React, { useLayoutEffect, useRef, useState } from 'react';
import { styled } from 'baseui';
import { CSS_VARIABLE_STAGE_VISIBLE_SCALE } from '../../../constants/stage-css-variables';
const PILL_GAP_ABOVE_ANCHOR = 6;
const PILL_PADDING_X = 6;
const PILL_PADDING_Y = 3;
const PILL_BORDER_RADIUS = 4;
const TEXT_LINE_HEIGHT = 16;
const PillGroup = styled<'g', {
  $originX: number;
  $originY: number;
  $annotationRotation: number;
}>('g', ({
  $originX,
  $originY,
  $annotationRotation
}) => ({
  transformOrigin: `${$originX}px ${$originY}px`,
  transform: `rotate(${$annotationRotation}rad) scale(var(${CSS_VARIABLE_STAGE_VISIBLE_SCALE}))`
}));
const PillText = styled('text', ({
  $theme
}) => ({
  ...$theme.typography.LabelXSmall,
  direction: 'ltr',
  userSelect: 'none',
  dominantBaseline: 'text-before-edge'
}));
type Props = {
  text: string;
  anchorCoords: [number, number];
  annotationRotation?: number;
  backgroundColor?: string;
  textColor?: string;
};
const AnnotationMetadataPill = ({
  text,
  anchorCoords,
  annotationRotation = 0,
  backgroundColor,
  textColor
}: Props) => {
  const textRef = useRef<SVGTextElement>(null);
  const [textWidth, setTextWidth] = useState(0);
  useLayoutEffect(() => {
    if (textRef.current) {
      setTextWidth(textRef.current.getBBox().width);
    }
  }, [text]);
  if (!text) {
    return null;
  }
  const [anchorX, anchorY] = anchorCoords;
  const pillHeight = TEXT_LINE_HEIGHT + PILL_PADDING_Y * 2;
  const pillWidth = textWidth + PILL_PADDING_X * 2;
  const pillY = anchorY - PILL_GAP_ABOVE_ANCHOR - pillHeight;
  return <PillGroup $originX={anchorX} $originY={anchorY} $annotationRotation={annotationRotation}>
      <rect x={anchorX} y={pillY} width={pillWidth} height={pillHeight} rx={PILL_BORDER_RADIUS} fill={backgroundColor || 'rgba(0, 0, 0, 0.7)'} opacity={textWidth ? 1 : 0} />
      <PillText ref={textRef} x={anchorX + PILL_PADDING_X} y={pillY + PILL_PADDING_Y} fill={textColor || '#fff'}>
        {text}
      </PillText>
    </PillGroup>;
};
export default AnnotationMetadataPill;